// Utility functions for M500 zone handling

export const validateM500Zone = (obj: any) => {
  try {
    if (!obj) {
      throw new Error("Invalid input");
    }

    const parsedObj = typeof obj === "string" ? JSON.parse(obj) : obj;
    return {
      PipeNum: parsedObj?.PipeNum ?? "-",
      PassNum: parsedObj?.PassNum ?? "-",
      ZoneNum: parsedObj?.ZoneNum ?? "-",
    };
  } catch (error) {
    return { PipeNum: "-", PassNum: "-", ZoneNum: "-" };
  }
};

// Helper function to check if a value is valid (not "!" and not null/undefined/empty)
const isValidValue = (val: any): boolean => {
  return val !== null && val !== undefined && val !== "" && val !== "!";
};

export const extractZoneAndPassForM500FromTableLimits = (
  tableLimits: any[],
  jobNumber: string,
  zoneObj: any
) => {
  try {
    if (!Array.isArray(tableLimits) || !jobNumber || !zoneObj) {
      throw new Error("Invalid input parameters");
    }

    const record = tableLimits.find(
      (item) => item.job_number === jobNumber && item.zone_name === zoneObj
    );

    const newZoneObj = validateM500Zone(zoneObj);
    const extractedData = {
      PipeNum: isValidValue(record?.pipe_name) 
        ? record.pipe_name 
        : `Pipe ${newZoneObj?.PipeNum}`,
      PassNum: isValidValue(record?.pass_name) 
        ? record.pass_name 
        : `Pass ${newZoneObj?.PassNum}`,
      ZoneNum: isValidValue(record?.m500_zone) 
        ? record.m500_zone 
        : `Zone ${newZoneObj?.ZoneNum}`,
    };

    return extractedData;
  } catch (error) {
    return { PipeNum: "-", PassNum: "-", ZoneNum: "-" };
  }
};

// New function to extract M500 zone details directly from the data object
export const extractM500ZoneDetailsFromData = (data: any) => {
  try {

    if (!data) {
      return { PipeNum: "-", PassNum: "-", ZoneNum: "-" };
    }

    // Parse the zone_name JSON string
    const zoneObj = validateM500Zone(data.zone_name);
    
    const extractedData = {
      PipeNum: isValidValue(data.pipe_name) 
        ? data.pipe_name 
        : `Pipe ${zoneObj?.PipeNum}`,
      PassNum: isValidValue(data.pass_name) 
        ? data.pass_name 
        : `Pass ${zoneObj?.PassNum}`,
      ZoneNum: isValidValue(data.m500_zone) 
        ? data.m500_zone 
        : `Zone ${zoneObj?.ZoneNum}`,
    };

    return extractedData;
  } catch (error) {
    return { PipeNum: "-", PassNum: "-", ZoneNum: "-" };
  }
};
